export default __webpack_public_path__ + "static/media/Onelogin_Mark_black_RGB.03b76d70.svg";